import { render, staticRenderFns } from "./MyShopTournamentsRanking.vue?vue&type=template&id=8bc0a0de"
import script from "./MyShopTournamentsRanking.vue?vue&type=script&lang=js"
export * from "./MyShopTournamentsRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports